import type { PurchaseChainOption } from 'src/utils/purchaseChains';

/**
 * How much the buyer transfers — quoted by api, never computed here.
 *
 * The app used to derive it: it sent `approximatePrice`, the listing price converted into USDT at a
 * hardcoded rate, in whatever token the chosen chain settles. On a EUR listing that token is EURC,
 * so a €5 car asked for 5.75 EURC and the buyer handed the seller the EUR/USD spread — while the
 * server recorded, and the verifier accepted, the plain €5.
 *
 * There is no conversion to do. The settling token is pegged to the listing's currency, so the
 * price *is* the amount, the same number on every chain the listing can be paid on. `amount` says
 * it, and `listing.price` is the same number for an api that predates the field.
 */
export const settlementAmount = (
  selected: PurchaseChainOption | undefined,
  listingPrice: number
): number => selected?.amount ?? listingPrice;
